import { render, staticRenderFns } from "./OperatnDocumentoInfo.vue?vue&type=template&id=5fb6910b&scoped=true&"
import script from "./OperatnDocumentoInfo.vue?vue&type=script&lang=ts&"
export * from "./OperatnDocumentoInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OperatnDocumentoInfo.vue?vue&type=style&index=0&id=5fb6910b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6910b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})
